import { changeMembership } from "@api/user";
import useAuth from "@hooks/useAuth";

const MembershipDropdown = () => {
  const { user } = useAuth();

  const handleMembershipChange = async (membership) => {
    try {
      const result = await changeMembership({ id: membership.id });

      if (result.data.brand_id === membership.brand_id) {
        window.location.reload();
      }
    } catch (error) {
      console.error("Error changing membership:", error);
    }
  };

  return (
    <select
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => {
        const membership = user.memberships.find(
          (m) => m.id === parseInt(e.target.value)
        );
        if (membership) handleMembershipChange(membership);
      }}
      value={user.memberships.find((m) => m.brand_id === user.brand_id)?.id}
      className="w-full appearance-none bg-transparent pl-6 pr-6 py-1 text-sm cursor-pointer focus:outline-none"
    >
      {user.memberships.map((membership) => (
        <option
          key={membership.id}
          value={membership.id}
          className="text-dark_night_sky"
        >
          {membership.name}
        </option>
      ))}
    </select>
  );
};

export default MembershipDropdown;
